<script lang="ts">
    export let textAlignment: 'left' | 'centered' = 'left';
</script>

<div
    class="content-scope-bar content-scope-bar--desktop"
    data-testid="content-scope-bar"
>
    <div
        class="content-scope-bar__content"
        class:content-scope-bar__content--centered={textAlignment ===
            'centered'}
        data-testid="content-scope-bar-content"
    >
        <slot />
    </div>
    <div
        class="content-scope-bar__controls typography-segmented-control"
        data-testid="content-scope-bar-controls"
    >
        <slot name="controls" />
    </div>
</div>

<style lang="scss">
    @use '@amp/web-shared-styles/sasskit-stylekit/ac-sasskit-config';
    @use 'amp/stylekit/core/mixins/materials' as *;

    .content-scope-bar {
        width: auto;
        height: 38px;
        position: sticky;
        top: 0;
        border: none;
        background-color: transparent;
        background-image: none;
        backdrop-filter: none;
        flex-shrink: 0;
        align-items: center;
        display: grid;
        grid-template-columns: 1fr auto;
        z-index: var(--z-web-chrome);

        @include system-header-material($detect-inactive: true);
    }

    .content-scope-bar__content {
        grid-row: 1;
        grid-column: 1;
        margin-inline-start: var(--bodyGutter);
        margin-inline-end: var(--bodyGutter);
    }

    .content-scope-bar__content--centered {
        text-align: center;
        grid-column: 1 / -1;
    }

    .content-scope-bar__controls {
        // Adjust end margin of header controls to align with edge of facehole in web chrome.
        // This margin changes width based on the web chrome and viewport width.
        $facehole-margin-mobile: 25px;
        $facehole-margin-compact-player: 15px;
        $facehole-margin-full-player: 20px;
        grid-row: 1;
        grid-column: 2;
        margin-inline-end: #{$facehole-margin-mobile};

        @media (--sidebar-visible) {
            margin-inline-end: #{$facehole-margin-compact-player};
        }

        @media (--small) {
            margin-inline-end: #{$facehole-margin-full-player};
        }
    }
</style>
